import {useContext} from "react";
import {ProjectFilterNumberContext} from "./project-filter-number-props.ts";

const useProjectFilterNumberContext = () => {
    const context = useContext(ProjectFilterNumberContext);
    if(!context) {
        throw new Error('useProjectFilterNumberContext must be used within a ProjectFilterNumberContext');
    }
    
    return context;
}

export default useProjectFilterNumberContext;